// Shared helpers for the Pipeline Health dashboard tabs.

// Domain → colour, used for the semaphore borders, chart strokes, etc.
// Anything not listed falls back to FALLBACK_COLOR.
export const DOMAIN_COLORS = {
  ama_legacy: '#16a34a',
  geotab: '#2563eb',
  hms: '#7c3aed',
  other: '#64748b',
  transdev: '#f59e0b',
  sonnell: '#ec4899'
};

export const FALLBACK_COLOR = '#64748b';

// Domain → human-readable label. Keep this in sync with DOMAIN_COLORS above.
// Unknown domains fall through to a snake_case → Title Case conversion so new
// domains coming from the backend don't show up as raw `foo_bar` strings.
const DOMAIN_LABELS = {
  ama_legacy: 'AMA (Legacy)',
  geotab: 'Geotab',
  hms: 'HMS',
  other: 'Other',
  transdev: 'Transdev',
  sonnell: 'Sonnell'
};

export function formatDomain(domain) {
  if (!domain) return '';
  if (DOMAIN_LABELS[domain]) return DOMAIN_LABELS[domain];

  // Snake_case → Title Case. The token "legacy" is special-cased: it's
  // pulled out and appended as " (Legacy)" at the end, matching the
  // convention used for the well-known `ama_legacy` label.
  const parts = domain.split('_').filter((p) => p.length > 0);
  const hasLegacy = parts.some((p) => p.toLowerCase() === 'legacy');
  const titled = parts
    .filter((p) => p.toLowerCase() !== 'legacy')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');

  if (!hasLegacy) return titled;
  return titled ? `${titled} (Legacy)` : '(Legacy)';
}

// Map the backend's HEALTHY / WARNING / CRITICAL status strings onto the
// Ant Design Tag colour palette.
export function statusToColor(status) {
  if (status === 'HEALTHY') return 'green';
  if (status === 'WARNING') return 'orange';
  if (status === 'CRITICAL') return 'red';
  return 'default';
}

// Map a health score (0–100) onto a colour. Used wherever the score is
// rendered as text so the colour reflects the bucket.
export function scoreColor(score) {
  if (score == null) return '#9ca3af';
  if (score >= 90) return '#16a34a';
  if (score >= 75) return '#84cc16';
  if (score >= 60) return '#f59e0b';
  return '#dc2626';
}

export function heatmapCellColor(score) {
  if (score === null) return '#e5e7eb';
  if (score === 1) return '#22c55e';
  if (score === 2) return '#f59e0b';
  return '#ef4444';
}

// Bucket label used in the distribution chart on page 2.
export const DISTRIBUTION_BUCKETS = [
  { key: 'noData', label: 'no_data', color: '#e5e7eb' },
  { key: 'critical', label: 'critical', color: '#dc2626' },
  { key: 'warning', label: 'warning', color: '#f59e0b' },
  { key: 'healthy', label: 'healthy', color: '#16a34a' }
];
